module.exports = __webpack_public_path__ + "img/pos.c3b92da1.svg";